var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewReply(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#E5F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4775 18.8106C28.7491 19.8308 30.3337 22.1343 30.3337 24.8125V27.625C30.3337 28.6605 29.5046 29.5 28.4818 29.5H22.9263C20.5073 29.5 18.4495 27.9347 17.6868 25.75M26.4775 18.8106C25.8929 16.338 23.6956 14.5 21.0744 14.5H20.1485C16.5689 14.5 13.667 17.4381 13.667 21.0625V23.875C13.667 24.9105 14.4961 25.75 15.5188 25.75H17.6868M26.4775 18.8106C26.5772 19.2323 26.63 19.6724 26.63 20.125C26.63 23.2316 24.1426 25.75 21.0744 25.75H17.6868",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReply);
export default __webpack_public_path__ + "static/media/new_reply.0a714d49c57e384e63e3300caff56d3f.svg";
export { ForwardRef as ReactComponent };